import { STAFF } from "../CONSTs"
/*  */
class Carousel {
    constructor(el, rev = false) {
        this.el = el

        this.rev = rev
        // Build
        this.build()
    }
    build() {
        this.container = document.createElement("div")
        this.dupe = document.createElement("div")
        this.container.classList.add("container")
        this.dupe.classList.add("dupe")
        this.el.appendChild(this.container)
        this.el.appendChild(this.dupe)

        if (this.rev == false) {
            for (let i = 0; i < STAFF.length; i++) {
                this.createUser(STAFF[i])
            }
        } else {
            for (let i = STAFF.length - 1; i >= 0; i--) {
                this.createUser(STAFF[i])
            }
        }
    }
    createUser(user) {
        const userTemplate = `
        <div class="user">
            <div class="img"><img src="/imgs/staff/${user.name}.svg"></div>
            <div class="info">
                <p class="name">${user.name}</p>
                <p class="bio">${user.bio}</p>
            </div>
        </div>
        `
        this.container.innerHTML += userTemplate
        this.dupe.innerHTML += userTemplate
    }
}
for (const carousel of document.querySelectorAll(".s-carousel")) {
    new Carousel(carousel)
}
for (const carousel of document.querySelectorAll(".s-carousel-rev")) {
    new Carousel(carousel, true)
}
